module.exports = __webpack_public_path__ + "img/Round-Solid.4fdbfbed.svg";